import { ChartColorsArray } from '@families-link/shared';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

type EngagementsPieChartProps = {
	data: any;
	title: string;
	useRandomColor?: boolean;
	colorsEnum?: any;
};

export const EngagementsPieChart = (props: EngagementsPieChartProps) => {
	const { data, title, useRandomColor = true, colorsEnum } = props;
	const [t] = useTranslation();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignContent: 'center',
				height: '100%',
			}}
		>
			<Typography
				sx={{
					color: (theme) => theme.colors.grayLightBlue,
					fontSize: { md: '12px', lg: '14px' },
					fontWeight: 500,
					pb: '12px',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{title}
			</Typography>
			<Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', flex: 1, height: '100%' }}>
				{data && data?.length ? (
					<Box sx={{ maxHeight: '110px', height: { md: '90px', lg: '110px' }, width: '100%' }}>
						<ResponsiveContainer width="100%" height="100%">
							<PieChart>
								<Pie
									data={data}
									dataKey="total"
									nameKey="pieChartKey"
									innerRadius="45%"
									outerRadius="100%"
									label={false}
								>
									{data?.map((entry: any, index: number) => (
										<Cell
											key={`cell-${index}`}
											fill={
												useRandomColor
													? ChartColorsArray[index % ChartColorsArray.length]
													: colorsEnum
													? colorsEnum[entry.pieChartKey]
													: entry?.pieChartColor
											}
										/>
									))}
								</Pie>
								<Legend align="right" verticalAlign="top" layout="vertical" content={CustomLegend} />
							</PieChart>
						</ResponsiveContainer>
					</Box>
				) : (
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<Typography sx={{ color: (theme) => theme.colors.grayLightBlue, fontSize: '16px', fontWeight: 500 }}>
							No data found for the chart
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};

const CustomLegend = (props: any) => {
	const { payload } = props;

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: '4px',
				ml: { md: 1, lg: 3 },
				overflowY: 'hidden',
				height: { md: '90px', lg: '110px' },
			}}
		>
			{payload.map((entry: any, index: number) => (
				<Box key={`item-${index}`} sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
					<Box
						sx={{
							width: 12,
							height: 12,
							borderRadius: '50%',
							backgroundColor: entry.color,
						}}
					/>
					<Typography
						noWrap
						title={entry.value}
						sx={{
							maxWidth: 66,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							color: (theme) => theme.colors.grayLightBlue,
							fontSize: '12px',
							fontWeight: 400,
						}}
					>
						{entry.value}
					</Typography>
				</Box>
			))}
		</Box>
	);
};
